import { useEffect, useRef, useState } from "react";
const allowKeyboards = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'Numpad0',
    'Numpad1',
    'Numpad2',
    'Numpad3',
    'Numpad4',
    'Numpad5',
    'Numpad6',
    'Numpad7',
    'Numpad8',
    'Numpad9',
    'Backspace',
    'Enter'
];
export const useInvitePhoneCallKeyBoard = (openPhone) => {
    const [phone, setPhone] = useState("");
    const callRef = useRef(null);
    useEffect(() => {
        const handleOnKeyNext = (event) => {
            var _a;
            if (!allowKeyboards.includes(event.key || event.code))
                return;
            event.preventDefault();
            if (['Enter'].includes(event.key || event.code)) {
                return (_a = callRef === null || callRef === void 0 ? void 0 : callRef.current) === null || _a === void 0 ? void 0 : _a.click();
            }
            setPhone(oldPhone => {
                if (['Backspace'].includes(event.key || event.code)) {
                    return oldPhone.slice(0, -1);
                }
                if (oldPhone.length >= 11)
                    return oldPhone;
                return oldPhone + event.key;
            });
        };
        if (openPhone) {
            document.addEventListener('keydown', handleOnKeyNext);
            return () => document.removeEventListener('keydown', handleOnKeyNext);
        }
    }, [openPhone]);
    return {
        setPhone,
        phone,
        callRef
    };
};
